<template>
  <v-menu offset-y :close-on-content-click="false" v-model="open">
    <template v-slot:activator="{ on, attrs }">
      <v-chip v-bind="attrs" v-on="on" small color="light" outlined :class="'px-0'+(typeof logClass==='undefined' ? '' : ' '+logClass)">
        <v-progress-circular v-if="stateLast.loading" color="primary" indeterminate size="14" width="2" class="ml-2"/>
        <div v-else>
          <v-icon small class="ml-2">mdi-history</v-icon>
          <span v-if="$tools.isEmpty(stateLast.data)" class="ml-1">Не найдено</span>
          <span v-else class="ml-1">
            <span v-if="stateLast.data.user">
              <span>{{stateLast.data.user.name}}</span>
              <span v-if="!$tools.isEmpty(stateLast.data.user.type)" class="pl-1">
                <span v-if="stateLast.data.user.type==='client'">(Клиент)</span>
                <span v-else-if="stateLast.data.user.type==='spec'">(Специалист)</span>
                <span v-else-if="stateLast.data.user.type==='admin'">(Админ)</span>
                <span v-else>{{stateLast.data.user.type}}</span>
              </span>
            </span>
            <span v-else>Аноним</span>
          </span>
        </div>
        <v-icon small class="ml-1 mr-2">mdi-chevron-down</v-icon>
      </v-chip>
    </template>
    <v-sheet max-width="400" max-height="600">
      <v-sheet v-if="stateList.loading" class="my-4 text-center" width="200">
        <v-progress-circular color="primary" indeterminate size="24" width="3" class="mx-1"/>
      </v-sheet>
      <div v-if="stateList.success">
        <v-sheet v-if="stateList.data.length===0" width="200">
          <alert>Не найдено</alert>
        </v-sheet>
        <v-expansion-panels accordion :multiple="false">
          <v-expansion-panel v-for="(log,key) in stateList.data" :key="key">
            <v-expansion-panel-header class="px-4 py-2">
              <div class="mr-2">
                <div class="subtitle-2">
                  <v-row no-gutters align="end">
                    <v-col class="mr-2 text-overflow">{{log.typeStr}} {{createAgo(log.date)}}</v-col>
                    <v-col cols="auto" class="caption mr-2 muted">{{$tools.dateTimeFormat(log.date, 'DD.MM.YYYY HH:mm')}}</v-col>
                  </v-row>
                  <div class="caption">
                    <div v-if="log.user===null" class="d-inline-block">Аноним</div>
                    <a v-else :href="'/panel/user/client/'+log.user.id+'/'" target="_blank" class="d-inline-block">
                      <span>{{log.user.name}}</span>
                      <span v-if="!$tools.isEmpty(log.user.type)" class="pl-1">
                        <span v-if="log.user.type==='client'">(Клиент)</span>
                        <span v-else-if="log.user.type==='spec'">(Специалист)</span>
                        <span v-else-if="log.user.type==='admin'">(Админ)</span>
                        <span v-else>{{log.user.type}}</span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="ml-n2">
              <div class="mt-n2">
                <!-- строка -->
                <div v-if="!Array.isArray(log.data)" class="body-2 mt-2" v-html="$tools.nl2br(log.data)"></div>
                <div v-else>
                  <!-- массив строк -->
                  <div v-for="(v,k) in log.data.filter(v=>!Array.isArray(v))" :key="k" class="body-2 mt-2">
                    <div v-html="$tools.nl2br(v)"></div>
                  </div>
                  <!-- массив массивов (неизвестные данные) -->
                  <div v-for="(v,k) in log.data.filter(v=>Array.isArray(v) && v.length!==2 && v.length!==3)" :key="k" class="body-2 mt-2">
                    {{v.join(' ')}}
                  </div>
                  <!-- массив массивов (элементы создания: поле, стало) -->
                  <v-simple-table v-if="log.data.filter(v=>Array.isArray(v) && v.length===2).length>0" dense class="transparent mt-2 table2">
                    <tbody>
                    <tr v-for="(v,k) in log.data.filter(v=>Array.isArray(v) && v.length===2)" :key="k">
                      <td class="text-no-wrap" style="vertical-align:top;line-height:32px">{{v[0]}}</td>
                      <td class="text-wrap">
                        <div class="d-inline-block" :class="v[1]==='__hide__' ? 'muted' : ''">
                          {{v[1]==='__hide__' ? 'скрыто' : v[1]}}
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                  <!-- массив массивов (элементы изменения: поле, было, стало) -->
                  <v-simple-table v-if="log.data.filter(v=>Array.isArray(v) && v.length===3).length>0" dense class="transparent mt-2 table2">
                    <tbody>
                    <tr v-for="(v,k) in log.data.filter(v=>Array.isArray(v) && v.length===3)" :key="k">
                      <td class="text-no-wrap" style="vertical-align:top;line-height:32px">{{v[0]}}</td>
                      <td class="text-wrap">
                        <div class="d-inline-block" :class="v[2]==='__hide__' ? 'muted' : ''">
                          {{v[2]==='__hide__' ? 'скрыто' : v[2]}}
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-sheet>
  </v-menu>
</template>

<script>
import Alert from "@/componentsV2/base/Alert.vue";
import axios from "axios";
import moment from "moment";
import Stater from "@/plugins/stater";

export default {
  components: {Alert},
  props: ['params','logClass'],
  data: () => ({
    stateLast: new Stater(),
    stateList: new Stater(),
    //queryLast:null,
    //queryList:null,
    open: false,
  }),
  mounted() {
    this.loadLast();
  },
  watch:{
    params(){
      this.loadLast();
      this.loadList();
    },
    open(){
      if(this.open)
        this.loadList();
      else
        this.$emit('close')
    }
  },
  methods: {
    loadLast(){
      let q = this.getQuery();
      //if(this.queryLast===q) return;
      //this.queryLast = q;

      this.stateLast.stateLoading()
      axios.get('/napi/log/last/?q='+q).then((r)=>{
        this.stateLast.data = r.data
        this.stateLast.stateSuccess()
      }).catch(() =>{
        this.stateLast.stateError()
      });
    },
    loadList(){
      if(this.open){
        let q = this.getQuery();
        //if(this.queryList===q) return;
        //this.queryList = q;

        this.stateList.stateLoading();
        axios.get('/napi/log/?q='+q).then(r=>{
          this.stateList.data = r.data;
          this.stateList.stateSuccess()
        }).catch(() =>{
          this.stateList.stateError()
        });
      }
    },
    getQuery(){
      if(this.$tools.isEmpty(this.params))
        return '';
      return this.params
          .filter(v=>!this.$tools.isEmpty(v[0]) && !this.$tools.isEmpty(v[0]))
          .map(v=>[v[0].includes('App\\') ? v[0] : 'App\\Entity\\'+v[0],v[1]])
          .map(v=>v[0]+':'+v[1])
          .join(',');
    },
    createAgo(v){
      return moment(v, 'YYYY-MM-DD HH:mm:ss').fromNow();
    }
  }
}
</script>
